module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Smart Pixel should be added to all your website pages right after Yandex.Metrica and Google Analytics counters.","showCode":"Show Code"},"ru":{"description":"Smart Pixel необходимо установить на все страницы вашего сайта сразу после счетчиков Яндекс.Метрики и Google Analytics.","showCode":"Показать Код"}}')
  delete Component.options._Ctor
}
